<script setup lang="ts">
    import { useAiAssistantStore } from '~/stores/aiAssistantStore';
    import { ENTITY_ICON_MAP, ENTITY_LABEL_KEY_MAP } from '~/utils/aiEntityMeta';

    const { t } = useTranslation();
    const store = useAiAssistantStore();

    const props = defineProps<{
        entity: { type: string; id: string; title: string | null };
    }>();

    const openPreview = () => {
        store.openPreview(props.entity.type, props.entity.id);
    };

    const icon = computed(() => ENTITY_ICON_MAP[props.entity.type] ?? 'fa-regular fa-file');
    const typeLabel = computed(() => t(ENTITY_LABEL_KEY_MAP[props.entity.type] ?? props.entity.type));

    // Yellow disc for "work product" (worksite/quote/order/delivery), grey disc for docs (invoice/credit-note/contact)
    const isYellowKind = computed(() => ['worksite', 'quote', 'order_slip', 'delivery_slip'].includes(props.entity.type));
</script>

<template>
    <button
        type="button"
        class="group w-full flex items-center gap-[10px] px-[10px] py-[9px] mb-[2px] rounded-[8px] border border-transparent bg-transparent text-left transition-colors hover:bg-[#FEFCF6] hover:border-[#E7E7E7] cursor-pointer"
        @click="openPreview"
    >
        <span
            class="w-8 h-8 flex-shrink-0 rounded-full flex items-center justify-center"
            :class="isYellowKind
                ? 'bg-[#FFC400] text-black'
                : 'bg-[#EEF2F7] text-[#42484E]'"
        >
            <i :class="icon" class="text-[13px]" />
        </span>

        <span class="flex-1 min-w-0">
            <span class="block font-inter text-[12px] font-medium text-[#0F1020] truncate">
                {{ entity.title ?? $t('ai.preview.no_title') }}
            </span>
            <span class="block font-inter text-[11px] text-[#8D929C] mt-[1px]">
                {{ typeLabel }}
            </span>
        </span>

        <i class="fa-solid fa-chevron-right text-[10px] text-[#ABB5C0]" />
    </button>
</template>
